import axios from 'axios'
import userStore from '@/store/user.js'

// 创建 axios 实例
const request = axios.create({
  baseURL: 'https://houtai5698.koiodeal.com/api',
  timeout: 10000
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 从 localStorage 获取 token
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user.token) {
      config.headers['token'] = user.token
      config.headers['type'] = user.type || 1 // 1:买家 2:卖家
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 1) {
      return res
    } else if (res.code === -1) {
      // 登录失效：清除本地状态并跳转登录页
      userStore.logout()
      window.location.href = '/#/'
      return Promise.reject(new Error(res.msg || 'Login expired'))
    } else {
      console.error('API Error:', res.msg)
      return Promise.reject(new Error(res.msg || 'Error'))
    }
  },
  error => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// 用户相关接口
export const userApi = {
  // 登录
  login(data) {
    return request({
      url: '/user/login',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 买家注册
  register(data) {
    return request({
      url: '/user/register',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 卖家注册
  sellerRegister(data) {
    return request({
      url: '/user/seller_register',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 获取账号信息
  getUserInfo() {
    return request({
      url: '/user/index',
      method: 'post'
    })
  },
  
  // 买家信息编辑
  editInfo(data) {
    return request({
      url: '/user/editinfo',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 卖家信息编辑
  editSellerInfo(data) {
    return request({
      url: '/user/editsellerinfo',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 积分提现
  cashout(score,paypaluser) {
    return request({
      url: '/user/cashout',
      method: 'post',
      data: { score,paypaluser },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 发送邮件
  sendEmail(data) {
    return request({
      url: '/user/sendyzm',
      method: 'post',
      data
    })
  },
  
  // 重置密码
  resetPassword(data) {
    return request({
      url: '/user/resetpwd',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

// 商品相关接口
export const productApi = {
  // 商品列表
  getProductList(data = {}) {
    return request({
      url: '/index/productlist',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 商品详情
  getProductDetail(id) {
    return request({
      url: '/index/productdetail',
      method: 'post',
      data: { id },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 添加评论
  addComment(data) {
    return request({
      url: '/index/addcomment',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 添加/取消收藏
  setCollect(product_id) {
    return request({
      url: '/index/setcollect',
      method: 'post',
      data: { product_id },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 收藏列表
  getCollectList() {
    return request({
      url: '/index/collectlist',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 更新购买链接点击次数
  updateTimes(product_id) {
    return request({
      url: '/index/updatetimes',
      method: 'post',
      data: { product_id },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 获取产品分类
  getProductCate() {
    return request({
      url: '/index/productcate',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 提交订单/下单
  submitOrder(product_id) {
    return request({
      url: '/index/submitorder',
      method: 'post',
      data: { product_id },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 订单列表
  getOrderList() {
    return request({
      url: '/index/orderlist',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 订单详情
  getOrderDetail(order_id) {
    return request({
      url: '/index/orderdetail',
      method: 'post',
      data: { order_id },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

// 其他接口
export const commonApi = {
  // 获取客户评价宣传数据
  gettestimonials() {
    return request({
      url: '/index/gettestimonials',
      method: 'post',
      data: { },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 获取FAQ
  getFaq(type) {
    return request({
      url: '/index/getfaq',
      method: 'post',
      data: { type },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 获取FAQ
  getbuylog() {
    return request({
      url: 'index/getbuylog',
      method: 'post',
      data: {  },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 获取配置数据
  getConfig() {
    return request({
      url: '/index/getconfig',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 联系我们
  contactUs(data) {
    return request({
      url: '/index/contactus',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  // 上传图片
  uploadImage(file) {
    const formData = new FormData()
    formData.append('file', file)
    return request({
      url: '/index/uploadimg',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default request
